<script setup>
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';
    import DccsInputField from "../DccsInputField/DccsInputField";
    import {defaultFieldProps} from "../../helpers/defaultProps";

    const { t } = useI18n();

    const props = defineProps({
        ...defaultFieldProps,

        type: {
            type: String,
            required: false,
            default: 'email',
        },

        pattern: {
            type: String,
            required: false,
            default: "^(?!.*(@ams.com)|.*(@ams-osram.com)|.*(@osram-os.com)|.*(@osram.com)).*$",
        },

        maxlength: {
            type: [Number, String],
            required: false,
            default: null,
        },

        errorMessage: {
            type: String,
            required: false,
            default: "",
        },

        fieldName: {
            type: String,
            required: true,
            default: "",
        },

        isRequired: {
            type: Boolean,
            required: true,
            default: false,
        },

        fieldLabel: {
            type: String,
            required: true,
            default: "",
        },

        fieldPlaceholder: {
            type: String,
            required: true,
            default: "",
        },

        fieldValue: {
            type: String,
            required: true,
            default: "",
        },

    });

    const errorMessageText = computed(() => {
        if(props.errorMessage !== "") {
            return props.errorMessage;
        } else {
            return t('errorMessage.emailPattern');
        }
    });

</script>

<template>
    <DccsInputField
        :type="type"
        :label="fieldLabel"
        :name="fieldName"
        :pattern="pattern"
        :required="isRequired"
        :placeholder="fieldPlaceholder"
        :value="fieldValue"
        :error-message="errorMessageText"
    ></DccsInputField>
</template>
